<template>
	<div class="mb-4">
		<BlackList></BlackList>
	</div>
</template>

<script>
import BlackList from '@/components/Widgets/BlackList/BlackList.vue';
export default {
  name: 'BlackListPage',
  components: {
    BlackList,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>